import * as api from '@utils/api'
import { AddonList } from '@types'

export const getAddonList = async (): Promise<AddonList> => {
  const response = await api.GET('/p4/addons')

  return response.data
}
